var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div><h4 class=\"clearfix m-b-0\"><span class=\"pull-left\">{{::$ctrl.title || 'Tags'}}</span> <a ng-click=\"$ctrl.editTags()\" class=\"pull-right\" ng-if=\"::!$ctrl.preventEdit\"><i class=\"fa fa-edit fa-lg\" aria-hidden=\"true\"></i></a></h4><hr class=\"hr-xs\"><tags-viewer ng-model=\"$ctrl.tags\" tag-kinds=\"$ctrl.tagKinds\"></tags-viewer></div>";
var id1="tags-card.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;